import { loadRemote } from '@module-federation/enhanced/runtime';
import { ensureMfRuntime } from '@/mf/runtime';

export const STUDIO_BASENAME = '/gosh/studio';

export type StudioNavItem = {
  path: string;
  name: string;
  icon: string;
};

type NavModule = {
  studioNav?: StudioNavItem[];
};

export function ensureStudioRuntime() {
  ensureMfRuntime();
}

let navTask: Promise<StudioNavItem[]> | null = null;

/** 左侧菜单跟子应用的 studioNav 走，失败时下次再拉。 */
export function loadStudioNav() {
  if (!navTask) {
    navTask = (async () => {
      ensureStudioRuntime();
      const mod = await loadRemote<NavModule>('goshStudio/nav');
      return mod?.studioNav ?? [];
    })().catch((err: unknown) => {
      navTask = null;
      throw err;
    });
  }
  return navTask;
}
